/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import Routes from 'ContentUtils/Routes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import PaymentLinkSelect from 'payment-link-components/components/PaymentLinkSelect';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import * as PaymentsActions from 'ContentData/actions/Payments';
import * as paymentsSelectors from 'ContentData/selectors/payments';
import { UNINITIALIZED } from 'ContentUtils/constants/RequestStatus';
import { PaymentsEligibilityStatus } from 'ContentData/types/redux/resources/payments';
import usePaymentLinkStatus, { PaymentLinkStatus } from 'payments-embed-points-lib/hooks/toolStatus/usePaymentLinkStatus';
import PaymentsEmbedPointContextProvider from 'payments-embed-points-lib/context/PaymentsEmbedPointContextProvider';
import PaymentsEmbedPointContext from 'payments-embed-points-lib/context/PaymentsEmbedPointContext';
import { getAppInfo } from 'payments-embed-points-lib/components/Modals/EnrollInHubSpotPaymentsPaymentLinksModal/utils';
// @ts-expect-error module cannot be typed
import { paymentMethodsImage } from '../../../../imgAssets';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.payment.${key}`;
function mapStateToProps(state) {
  return {
    hasFetchedPaymentEligibility: paymentsSelectors.getHasFetchedPaymentEligibility(state),
    isLoading: paymentsSelectors.getIsLoading(state),
    paymentEligibility: paymentsSelectors.getPaymentEligibility(state),
    payments: paymentsSelectors.getPayments(state),
    paymentsFetchStatus: paymentsSelectors.getPaymentsFetchStatus(state)
  };
}
const mapDispatchToProps = {
  fetchPayments: PaymentsActions.fetchPayments,
  fetchPaymentEligibility: PaymentsActions.fetchPaymentEligibility
};
const SetUpPaymentsButton = ({
  trackFieldAction,
  use
}) => {
  const {
    getPaymentsInterstitialModalOpenHandler
  } = useContext(PaymentsEmbedPointContext);
  const handleClick = () => {
    if (trackFieldAction) {
      trackFieldAction('clicked-set-up-payments-button', {});
    }
  };
  const onClickHandler = getPaymentsInterstitialModalOpenHandler(handleClick);
  return /*#__PURE__*/_jsx(Button, {
    onClick: onClickHandler,
    size: "extra-small",
    use: use || 'tertiary-light',
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('preEnrollmentAlert.setUpPaymentsButton')
    })
  });
};
const CreatePaymentLinkButton = ({
  trackFieldAction
}) => {
  const handleClick = () => {
    if (trackFieldAction) {
      trackFieldAction('clicked-create-payment-link-button', {});
    }
  };
  return /*#__PURE__*/_jsx(Button, {
    external: true,
    href: Routes.paymentLinks(),
    onClick: handleClick,
    size: "extra-small",
    use: "tertiary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('preEnrollmentAlert.createPaymentLinkButton')
    })
  });
};
const PaymentAlert = props => {
  const {
    titleTextMsg,
    children
  } = props;
  return /*#__PURE__*/_jsx(Alert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: titleTextMsg
    }),
    "data-selenium": props['data-selenium'],
    paddingBlock: "400",
    children: /*#__PURE__*/_jsx(ButtonWrapper, {
      children: children
    })
  });
};
const PaymentSelect = ({
  fetchPaymentEligibility,
  fetchPayments,
  hasFetchedPaymentEligibility,
  isLoading,
  error,
  onFieldChange,
  paymentEligibility,
  payments,
  paymentsFetchStatus,
  placeholder,
  required,
  readOnly,
  trackFieldAction,
  useOnDark,
  value
}) => {
  useEffect(() => {
    if (!hasFetchedPaymentEligibility) {
      fetchPaymentEligibility();
    }
  }, [hasFetchedPaymentEligibility, fetchPaymentEligibility]);
  const {
    paymentLinkStatus,
    isLoading: isPaymentLinkStatusLoading
  } = usePaymentLinkStatus();
  useEffect(() => {
    const shouldFetchDueToStatus = paymentLinkStatus === PaymentLinkStatus.PRE_ENROLL_POST_TOOL || paymentLinkStatus === PaymentLinkStatus.POST_ENROLL_POST_TOOL;
    const shouldFetchDueToEligibility = hasFetchedPaymentEligibility && paymentEligibility.status === PaymentsEligibilityStatus.ACCOUNT_EXISTS && paymentEligibility.chargesEnabled;
    if (paymentsFetchStatus === UNINITIALIZED && (shouldFetchDueToStatus || shouldFetchDueToEligibility)) {
      fetchPayments();
    }
  }, [fetchPayments, hasFetchedPaymentEligibility, paymentEligibility.chargesEnabled, paymentEligibility.status, paymentLinkStatus, paymentsFetchStatus]);
  const {
    openUpgradeModal
  } = useUpgradeModal('payments-cms-module');
  const paymentId = value && value.id;
  function onChange(evt) {
    const newPaymentId = evt.target.value;
    const payment = payments.find(({
      id
    }) => id === Number(newPaymentId));
    if (payment && trackFieldAction) {
      trackFieldAction('payment-field-payment-selected', {
        total: payment.subtotals.firstPaymentTotal
      });
    }
    onFieldChange({
      id: newPaymentId
    });
  }
  const {
    status
  } = paymentEligibility;
  if (isLoading || isPaymentLinkStatusLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered",
      paddingBlock: "300"
    });
  }

  // a free account can NOT add a payment field, so this should not render
  // this is here in case this state ever occurs
  if (status === PaymentsEligibilityStatus.INELIGIBLE) {
    return /*#__PURE__*/_jsxs(PaymentAlert, {
      "data-selenium": "payment-field-ineligible-alert",
      titleTextMsg: i18nKey('emptyNoPaymentsAccessAlert.title'),
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('emptyNoPaymentsAccessAlert.message')
      }), /*#__PURE__*/_jsx(Button, {
        onClick: openUpgradeModal,
        size: "extra-small",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('upgrade')
        })
      })]
    });
  }
  const {
    appName,
    screen,
    subscreen
  } = getAppInfo();
  switch (paymentLinkStatus) {
    case PaymentLinkStatus.PRE_ENROLL_PRE_TOOL:
      return /*#__PURE__*/_jsx(PaymentAlert, {
        "data-selenium": "payment-field-pre-enrollment",
        titleTextMsg: i18nKey(`preEnrollmentAlert.title.${appName}`),
        children: /*#__PURE__*/_jsxs(ButtonWrapper, {
          children: [/*#__PURE__*/_jsx(CreatePaymentLinkButton, {
            trackFieldAction: trackFieldAction
          }), /*#__PURE__*/_jsx(PaymentsEmbedPointContextProvider, {
            appName: appName,
            screen: screen,
            subscreen: subscreen,
            children: /*#__PURE__*/_jsx(SetUpPaymentsButton, {
              trackFieldAction: trackFieldAction
            })
          })]
        })
      });
    case PaymentLinkStatus.PRE_ENROLL_POST_TOOL:
      {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(PaymentLinkSelect, {
            buttonUse: useOnDark ? 'form-on-dark' : 'form',
            clearable: !required,
            error: error,
            placeholder: placeholder,
            onChange: onChange,
            paymentLinks: payments
            // @ts-expect-error Type is supported but not explicitly typed
            ,
            readOnly: readOnly,
            value: paymentId,
            disabledOptions: true,
            disabledOptionsReason: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('preEnrollPostToolAlert.paymentLinkDisabledReason')
            })
          }), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "500",
            children: /*#__PURE__*/_jsxs(PaymentAlert, {
              "data-selenium": "payment-field-pre-enrollment",
              titleTextMsg: i18nKey(`preEnrollPostToolAlert.title.${appName}`),
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey(`preEnrollPostToolAlert.message.${appName}`)
              }), /*#__PURE__*/_jsx(PaymentsEmbedPointContextProvider, {
                appName: appName,
                screen: screen,
                subscreen: subscreen,
                children: /*#__PURE__*/_jsx(SetUpPaymentsButton, {
                  trackFieldAction: trackFieldAction,
                  use: "tertiary"
                })
              }), /*#__PURE__*/_jsx(Image, {
                "data-test-id": "payment-methods-image",
                alt: "Payment Methods",
                maxBlockSize: "25px",
                src: paymentMethodsImage
              })]
            })
          })]
        });
      }
    case PaymentLinkStatus.POST_ENROLL_PRE_TOOL:
      return /*#__PURE__*/_jsx(PaymentAlert, {
        "data-selenium": "payment-field-empty-alert",
        titleTextMsg: i18nKey(`postEnrollmentAlert.title.${appName}`),
        children: /*#__PURE__*/_jsxs(ButtonWrapper, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(`postEnrollmentAlert.message.${appName}`)
          }), /*#__PURE__*/_jsx(CreatePaymentLinkButton, {
            trackFieldAction: trackFieldAction
          })]
        })
      });
    case PaymentLinkStatus.POST_ENROLL_POST_TOOL:
      return /*#__PURE__*/_jsx(PaymentLinkSelect, {
        buttonUse: useOnDark ? 'form-on-dark' : 'form',
        clearable: !required,
        error: error,
        placeholder: placeholder,
        onChange: onChange,
        paymentLinks: payments
        // @ts-expect-error Type is supported but not explicitly typed
        ,
        readOnly: readOnly,
        value: paymentId
      });
    default:
      return /*#__PURE__*/_jsx(PaymentAlert, {
        "data-selenium": "payment-field-empty-no-read-alert",
        titleTextMsg: i18nKey('emptyNoWriteAccessAlert.title'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('emptyNoWriteAccessAlert.message')
        })
      });
  }
};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentSelect);